import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-payment-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './payment-layout.component.html',
  styleUrl: './payment-layout.component.scss',
})
export class PaymentLayoutComponent {}
